export const getLanguageCode = (val: string | undefined | null) => {
  switch (val) {
    case 'es':
      return 'es';

    default:
      return 'en';
  }
};
